import { CoeDataAnalysisUIModel } from "src/store/models/ui/coeDataAnalysis/coeDataAnalysis";
import { CoeDataAnalysisTableUIModel } from "src/store/models/ui/coeDataAnalysis/coeDataAnalysisTable";

export const encooCoeDataAnalysisUIModels = {
  coeDataAnalysisTable: CoeDataAnalysisTableUIModel,
  coeDataAnalysis: CoeDataAnalysisUIModel,
};
